import React from 'react';

type CommissionType = {
  id: number;
  commissionPercentage: number;
  isActive: boolean;
  description?: string;
  validFrom?: string;
  validUntil?: string;
};

interface CommissionSectionProps {
  commission: CommissionType | null;
  primaryColor: string;
}

const CommissionSection: React.FC<CommissionSectionProps> = ({
  commission,
  primaryColor,
}) => {
  if (!commission) return null;

  return (
    <div className="mt-4 p-3 bg-light rounded">
      <h5 className="mb-3" style={{ color: primaryColor }}>Commission de fidélité</h5>
      <div className="row">
        <div className="col-md-6">
          <p><strong>Pourcentage:</strong> {commission.commissionPercentage.toFixed(2)}%</p>
          <p>
            <strong>Etat:</strong>
            <span className={`badge ms-2 ${commission.isActive ? 'bg-success' : 'bg-secondary'}`}>
              {commission.isActive ? 'Active' : 'Inactive'}
            </span>
          </p>
          {commission.description && (
            <p><strong>Description:</strong> {commission.description}</p>
          )}
        </div>
        <div className="col-md-6">
          {commission.validFrom && (
            <p><strong>Début:</strong> {new Date(commission.validFrom).toLocaleDateString("fr-FR")}</p>
          )}
          {commission.validUntil && (
            <p><strong>Fin:</strong> {new Date(commission.validUntil).toLocaleDateString("fr-FR")}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default CommissionSection;